import * as React from "react";

import { SuccessMessage } from "@origin-digital/messages";
import {
  Button,
  Card,
  CardStackSection,
  Stack,
} from "@origin-digital/ods-core";
import { navigationClose } from "@origin-digital/event-dispatcher";

import { updateActionBar } from "src/utils/notifications";

export interface ISuccessProps {
  done: string;
  heading: string;
  navComplete?: (result: Record<string, unknown>) => void;
  text: string;
}

export const Success = ({
  done,
  heading,
  navComplete,
  text,
}: ISuccessProps) => {
  if (typeof navComplete === "function") {
    navComplete({});
  }

  updateActionBar();

  return (
    <CardStackSection data-id="success">
      <Card>
        <Stack space={["large", "xlarge"]}>
          <SuccessMessage heading={heading} text={text} />
          <Button data-id="continue" fullWidth onClick={navigationClose}>
            {done}
          </Button>
        </Stack>
      </Card>
    </CardStackSection>
  );
};
